import { IconPropsInterface } from "./typings"
export default function BoxIcons({ icon, className = "", solid = false }: IconPropsInterface) {
    return (<i className={`bx ${solid ? "bxs" : "bx"}-${icon} ${className}`}></i>);
}
